import { Component, Input } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "../../services/user.service";
import { ConfirmModalComponent } from "../confirm-modal/confirm-modal.component";

@Component({
  selector: "app-user-profile-modal",
  templateUrl: "./user-profile-modal.component.html",
  styleUrl: "./user-profile-modal.component.scss",
})
export class UserProfileModalComponent{
  @Input() user!: any; // User details will be passed when opening the modal
  loading = false;
  loadingStatus = false;
  resettingQuestionnaire = false;

  USER_ROLE_MAPPING: Record<string, string> = {
    HospitalAdmin: "Hospital Administrator",
    Coordinator: "Coordinator",
    Provider: "Provider",
    Donor: "Donor",
  };

  resettingPassword = false; // Track password reset state
  tempPassword = ""; // Temporary password input
  successMessage: string | null = null;
  errorMessage: string | null = null;
  showPassword = false; // Toggle password visibility

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private userService: UserService
  ) {}


  closeModal() {
    this.activeModal.close();
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  initiatePasswordReset() {
    this.resettingPassword = true;
  }

  confirmPasswordReset() {
    if (!this.tempPassword) {
      return;
    }

    this.loading = true;

    this.userService
      .resetPassword(this.user.email, this.tempPassword)
      .subscribe({
        next: () => {
          this.successMessage = `Temporary password set successfully!`;
          this.resettingPassword = false;
          this.loading = false;
        },
        error: (error: any) => {
          this.errorMessage = error.error.error || "Failed to reset password.";
          this.loading = false;
        },
      });
  }

  getNameOrEmail(donor: any) {
    if (donor?.firstName && donor?.lastName) {
      return `${donor.firstName} ${donor.lastName}`;
    } else {
      return donor.email;
    }
  }

  resetDonorQuestionnaire(donor: any) {
    const modalRef = this.modalService.open(ConfirmModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.donorEmail = donor.email;
    modalRef.componentInstance.actionType = "resetQuestionnaire";
    modalRef.componentInstance.title = "Confirm Reset";
    modalRef.componentInstance.message = `Are you sure you want to reset the questionnaire for </br> <strong> ${this.getNameOrEmail(donor)} </strong> </br> This action cannot be undone.`;

    modalRef.result
      .then((confirmed) => {
        if (confirmed) {
          this.resettingQuestionnaire = true;
          this.activeModal.close({
            status: "success",
            action: "resetQuestionnaire",
          });
        }
      })
      .catch(() => {});
  }

  toggleUserStatus() {
    this.loadingStatus = true;

    if (this.user.enabled) {
      this.userService.deactivateUser(this.user.email).subscribe({
        next: () => {
          this.user.enabled = false;
          this.successMessage = "User successfully deactivated!";
        },
        error: () => {
          this.errorMessage = "Failed to deactivate user.";
        },
        complete: () => {
          this.loadingStatus = false;
        },
      });
    } else {
      this.userService.activateUser(this.user.email).subscribe({
        next: () => {
          this.user.enabled = true;
          this.successMessage = "User successfully activated!";
        },
        error: () => {
          this.errorMessage = "Failed to activate user.";
        },
        complete: () => {
          this.loadingStatus = false;
        },
      });
    }
  }
}
